import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
import { Button } from 'reactstrap';
import MUIDataTable from "mui-datatables";

// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';
import CircularProgress from '@mui/material/CircularProgress';

import {
   parentViewDocument,
   fetchStudentDocument,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

import ViewElement from '../students/component/viewdocument';

class viewDocumentParent extends Component {

   constructor(props) {

      super(props);
      this.confirmationDialog = React.createRef();
      this.state = {
         viewdiv: true,
         editdiv:false,
         vfm:2,
         cstid:'',

      };

      this.onBackSection = this.onBackSection.bind(this);      
   }

   UNSAFE_componentWillMount() {
      this.props.parentViewDocument();
   } 
   
   onBackSection() {
      this.setState({
         viewdiv: true,
         editdiv: false,

      });
   }


   viewSession(id){
    
        this.props.fetchStudentDocument(id).then((data) => {   
            this.setState({
                cstid:id,
                viewdiv: false,
                editdiv: true,

            });
        });   
   }

   onBackDashboard(){
      window.location.replace('/app/parentdashboard');
   }

   

   render() {
      const { match, allparentdocument, loading } = this.props;
      const usrid=localStorage.getItem('user_id'); 
      const options = {
         filterType: 'dropdown',
         rowsPerPage: 50,
         responsive:'standard',
         rowsPerPageOptions: [50, 100, 150],
         selectableRowsHideCheckboxes: true,
      };

      const columns = [
         { name: "no", label: "NO" },
         { name: "type", label: "FILE NAME" },
         { name: "excdate", label: "DESCRIPTION" },
         { name: "action", label: "View" }
      ];

      const tabledata = allparentdocument.map((assmntval, idx) => {
         const ebtn = (<button class="mr-10 mb-10 btn btn-info btn-sm" onClick={() => this.viewSession(assmntval.csdID)}>View</button>);
         

         return {
            no: idx + 1,
            type: assmntval.csd_filename,
            excdate: assmntval.csd_desc,
            action: ebtn,
         };
      });
      return (
         <div className="saas-dashboard">
            <Helmet>
               <title> View Document | {AppConfig.appTitle}</title>
               <meta name="description" content="Golf" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.viewdocument" />} match={match} />

            {this.state.viewdiv &&
               <div className="col-sm-12 col-lg-12">
                  <RctCollapsibleCard heading="List" backtoadd fullBlock onClick={this.onBackDashboard}>
                     <MUIDataTable
                        data={tabledata}
                        columns={columns}
                        options={options}
                     />
                  </RctCollapsibleCard>
               </div>
            }

                {this.state.editdiv &&
                    <ViewElement onClick={this.onBackSection} data={this.state} />
                }
            

         </div>
      )
   }
}

const mapStateToProps = ({ contractstudent }) => {
   const { allparentdocument, loading } = contractstudent;
   return { allparentdocument, loading };
}

export default connect(mapStateToProps, {
    parentViewDocument,
   fetchStudentDocument,
})(viewDocumentParent); 